import { Button, Col, Row, Space } from 'antd'
import { MintButton } from './MintButton'

export const MobileStickyContent = (): JSX.Element => {
  return (
    <div className={'mobil-show-buttons'}>
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} align={'middle'}>
          <Col sm={24} xs={24} md={24} lg={0}><MintButton isMintBtnBlock={true} /></Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} align={'middle'}>
          <Col sm={24} xs={24} md={24} lg={0}><Button block href={'/collections'}>VIEW COLLECTION</Button></Col>
        </Row>
      </Space>
    </div>
  )
}
